module.exports = __webpack_public_path__ + "img/background_polygons.e2169a40.gif";